import { rd } from '@passionware/monads';
import { appScopeUtils } from 'v5/core/app-scope/appScope.types';
import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';
import { mySystemSettingsService } from './SystemSettingsService.connected';

/** v1 bridge. v5 callers use `systemSettingsService.useSetting`. */
export function useBrowsingDefaultCurrency(): string | undefined {
  const settingRd = mySystemSettingsService.useSetting(
    myAppScopeService.useResolvedScopeIdentity(),
    'defaults_currency'
  );
  return rd.tryGet(settingRd)?.value;
}

/** Null workspace id reads the organization row. */
export async function ensureDefaultCurrencyForWorkspace(
  organizationId: string,
  enterpriseWorkspaceId: number | null
): Promise<string | undefined> {
  try {
    const setting = await mySystemSettingsService.ensureSetting(
      appScopeUtils.identityFromEntityWorkspace(
        organizationId,
        enterpriseWorkspaceId
      ),
      'defaults_currency'
    );
    return setting.value;
  } catch {
    return undefined;
  }
}
